import React from 'react';
import { Switch, Route } from 'react-router-dom';

import Show from 'components/Show';
import Update from 'components/Update';

import Me from 'containers/Me';
import Home from 'containers/Administrator/Home';
import Users from 'containers/Administrator/Users';
import Articles from 'containers/Administrator/Articles';
import Documents from 'containers/Administrator/Documents';
import Programs from 'containers/Administrator/Programs';
import Blanks from 'containers/Administrator/Blanks';
import Subjects from 'containers/Administrator/Subjects';
import Grades from 'containers/Administrator/Grades';
import Courses from 'containers/Administrator/Courses';
import Materials from 'containers/Administrator/Materials';
import Exams from 'containers/Administrator/Exams';
import Results from 'containers/Administrator/Results';
import Webinars from 'containers/Administrator/Webinars';
import Finals from 'containers/Administrator/Finals';
import Logs from 'containers/Administrator/Logs';
import Nothing from 'containers/System/404';

import Test from 'containers/Administrator/Test';

import { useAppStore } from 'store/useAppStore';

const Administrator = ({ role }) => {
	const update = useAppStore(state => state.update);

	return (
		<div className="app__content">
			{/* App's version update notification */}
			<Show if={update}>
				<Update />
			</Show>
						
			<Switch>
				<Route path="/" exact>
					<Home />
				</Route>

				<Route path="/me">
					<Me />
				</Route>

				<Route path="/users">
					<Users />
				</Route>

				<Route path="/new/users">
					<Users />
				</Route>

				<Route path="/articles">
					<Articles />
				</Route>

				<Route path="/documents">
					<Documents />
				</Route>

				<Route path="/programs">
					<Programs />
				</Route>

				<Route path="/blanks">
					<Blanks />
				</Route>

				<Route path="/subjects">
					<Subjects />
				</Route>

				<Route path="/grades">
					<Grades />
				</Route>

				<Route path="/courses">
					<Courses />
				</Route>

				<Route path="/materials">
					<Materials />
				</Route>

				<Route path="/exams">
					<Exams />
				</Route>

				<Route path="/results">
					<Results />
				</Route>

				<Route path="/webinars">
					<Webinars />
				</Route>

				<Route path="/finals">
					<Finals />
				</Route>

				<Route path="/test">
					<Test />
				</Route>

				<Show if={role === 'admin'}>
					<Route path="/logs">
						<Logs />
					</Route>
				</Show>

				<Route path="/*">
					<Nothing />
				</Route>
			</Switch>
		</div>
	);
};

export default Administrator;
